import { Component,Inject, ViewEncapsulation } from '@angular/core';
import { MatDialogRef } from '@angular/material';
import { Subscription } from 'rxjs/Subscription';
import { MAT_DIALOG_DATA} from '@angular/material';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NotifierService } from '../../../shared/notifier/notifier.service';

@Component({
  selector: 'app-discount-modal',
  templateUrl: `discountModal.html`,
  encapsulation: ViewEncapsulation.None,
})
export class DiscountModalComponent {

  modalTitle = '';
  buttonText = '';
  submitted = false;
  subscription: Subscription;
  action: string;
  summit: boolean;
  discount = {mode: '' ,details: '', value: 0, type: 1 , lineSelect: 0};
  registerForm: FormGroup;
  constructor(public dialogRef: MatDialogRef<DiscountModalComponent>,
    @Inject(MAT_DIALOG_DATA) public dialogData: any,
    private formBuilder: FormBuilder,
    private notifierService: NotifierService,
    ) {
      this.discount.lineSelect = dialogData[0].line;
      if (this.discount.type == 1){
        this.registerForm = this.formBuilder.group({
          detail: ['', Validators.required],
          discount_type: ['', Validators.required],
          discount_mode: ['', Validators.required],

          discount_line: ['', Validators.required],
          value: ['', [Validators.required, Validators.max(100),Validators.min(0)]]
        });
      } else {
        this.registerForm = this.formBuilder.group({
          detail: ['', Validators.required],
          discount_type: ['', Validators.required],
          discount_mode: ['', Validators.required],

          discount_line: ['', Validators.required],
          value: ['', [Validators.required]]
        });
      }
    }

  get f() { return this.registerForm.controls; }

  close() {
    this.dialogRef.close();
  }

  changePorcent() {
      if (this.discount.value > 100 || this.discount.value < 0){
        this.discount.value = 0;
      }
  }

  changeMount() {
    if (this.discount.value < 0){
        this.discount.value = 0;
    }
  }

  public onSave() {
    this.submitted = true;
    if (this.discount.details != ''){
        this.dialogRef.close(this.discount);
    }else{
      this.notifierService.systemNotify({
        title: 'Error',
        message: 'Complete todos los campos',
        type: 'error',
        duration: 5000
      });
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/system/billing/new-billing/modal/discountModal.component.ts